import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'jobName',
                label: '任务描述',
                type: 'input'
            },
            {
                prop: 'remark',
                label: '实例名称',
                type: 'input',
            },
            {
                prop: 'jobStatus',
                label: '状态',
                type: 'select',
                selectval: comMapping.$taskStatus
            }
        ],
        searchdata: {
            jobName: '',
            remark: '',
            jobStatus: ''
        },
        headData: [
            {
                title: '任务描述',
                prop: 'jobName',
                width: 110,
                custom: true

            },
            {
                title: '实例名称',
                prop: 'remark',
                width: 130,
                custom: true

            },
            {
                title: '状态',
                prop: 'jobStatus',
                width: 50,
                custom: true

            },
            {
                title: '最后一次执行时间值',
                prop: 'updateDate',
                width: 130,
                custom: true

            },
            {
                title: '定时参数',
                prop: 'cronExpression',
                width: 160,
                custom: true

            },
            {
                title: '操作人',
                prop: 'updateBy',
                custom: true,
                fixed: 'right',
                width: 250
            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 150
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
